import { lazy, Suspense } from 'react';

import { AuthGuard } from 'src/auth/guard';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const SetupPage = lazy(() => import('src/pages/onboarding/setup'));

// ----------------------------------------------------------------------

// Guided setup sits outside the dashboard layout on purpose: no sidebar, no navigation, nothing to
// wander into. AuthGuard still applies, so a seller reaches it signed in and subscribed. It is not
// wrapped in OnboardingGuard — that guard is what sends people here.
export const setupRoutes = [
  {
    path: 'setup',
    element: (
      <AuthGuard>
        <Suspense fallback={<SplashScreen />}>
          <SetupPage />
        </Suspense>
      </AuthGuard>
    ),
  },
];
